import axios from "../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
	const { setAuth } = useAuth();

	const refresh = async (auth) => {
		const response = await axios.post("/user/refresh-token.json", undefined, {
			headers: { Authorization: `Bearer ${auth.data.token}` },
		});
		setAuth({ ...response.data, date: new Date() });
		localStorage.setItem("user", JSON.stringify({ ...response.data, date: new Date() }));
		return response;
	};
	return refresh;
};

export default useRefreshToken;
